module.exports = __webpack_public_path__ + "static/media/AS-Snjoll.b80a13c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/brand/brands/as/media/AS-Snjoll.png
// module id = 329
// module chunks = 0